import React from 'react'

import { ReactComponent as SmileySad } from '../../img/svg/smiley-sad.svg';
import { ReactComponent as ArrowRight } from '../../img/svg/arrow-right.svg';

import { Container, Button } from './styles';

export default function PerformanceCFPNotExist() {
  return (
    <Container>
      <SmileySad />
      <span className='vish'>Vish!</span>
      <span className='text'>
        Você não realizou nenhuma prova até o momento.
        <br />
        Fale com seu professor para iniciar as suas aulas.
      </span>
      <a
        href={`${process.env.REACT_APP_SUPPORT_URL}?text=${encodeURIComponent('Olá! Gostaria de entrar em contato')}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Button>
          <span className='text-button'>Falar com meu professor</span>
          <ArrowRight />
        </Button>
      </a>
    </Container>
  )
}
